/** ----------------------------------------
    Imports
---------------------------------------- */

import anime from 'animejs';
import axios from 'axios';

/** ----------------------------------------
     Map Filter
 ---------------------------------------- */

export class LoadMore {

    constructor() {
        this.containerEl = document.getElementById('loadmore-container');

        if (!this.containerEl)
            return;

        this.endpoint = `${ window.location.origin }${this.containerEl.dataset.endpoint}`;
        this.url = new URL(window.location);

        if(!this.endpoint)
            return;

        this.resultsEl = document.getElementById('loadmore-results');
        this.loadMoreEl = document.querySelector('#js-loadmore');

        this._init();
    }

    /**
     * add load more listener
     */
     addLoadMoreListeners() {
        this.loadMoreEl.addEventListener('click', () => {
            event.preventDefault();
            this.loadMore();
        });
    }

    /**
     * load more
     */
     loadMore() {
        let page = this.url.searchParams.get('page');
        page = page ? page : 0;
        page++;

        this.url.searchParams.set('page', page);

        history.pushState({}, null, this.url);

        this.filter(true);
    }

    /**
     * append
     * @param  {bool} append
     */
     filter(append = false) {
        this.getResults().then(data => {
            this.updateDom(data, append);
        });
    }

    /**
     * get results
     */
     getResults() {
        if (this.fetching) return;

        this.fetching = true;

        let url = this.endpoint + this.url.search;

        return axios.get(url).then(response => {
            this.fetching = false;
            return response.data;
        });
    }

    /**
     * update results dom
     * @param  {object} data
     * @param  {bool} append
     */
     updateDom(data, append = false) {
        if (!append)
            this.resultsEl.innerHTML = '';

        this.resultsEl.innerHTML+= data.dom;

        this.loadMoreEl.style.display = data.finished ? 'none' : '';
        this.resultsEl.style.paddingBottom = '1.5rem';
    }

    /** ----------------------------------------
        Init
    ---------------------------------------- */

    _init() {
        this.addLoadMoreListeners();
    }
}
